import { scan } from "react-scan";
import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import { LanguageProvider } from "./LanguageContext";
import config from "../config";
import "./css/style.css";
// import "jsvectormap/dist/css/jsvectormap.css";
import "flatpickr/dist/flatpickr.min.css";
import { Provider as RollbarProvider, ErrorBoundary } from "@rollbar/react";
import * as Sentry from "@sentry/react";
import { initUserback } from "./services/userback/userbackClient";

scan({
  enabled: import.meta.env.DEV,
});

function ErrorFallback({
  error,
  resetError
}: {
  error: Error | null;
  resetError: () => void;
}) {
  const [buttonVisible, setButtonVisible] = useState(true);
  const handleReportError = () => {
    if (error) {
      // @ts-ignore
      window.Rollbar?.error(error, {
        manualSubmission: true,
        timestamp: new Date().toISOString(),
        userAction: 'manual_report',
        browserInfo: navigator.userAgent
      });
      setButtonVisible(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };


  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold">Възникна неочаквана грешка</h1>
      <p>{error ? error.message : "Възникна неочаквана грешка."}</p>
      {buttonVisible && (
        <button onClick={handleReportError} className="mt-4 bg-primary text-white px-4 py-2 rounded hover:bg-opacity-90">Докладвай грешката към администраторите</button>
      )}

    </div>
  );
}


Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/prep\.trakia-uni\.bg/],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});

const getUserData = () => {
  const email = localStorage.getItem("email") || "";
  const teacherId = localStorage.getItem("teacherId") || "";

  if (!email && !teacherId) {
    return undefined;
  }

  return {
    user_data: {
      id: email || teacherId || "anonymous",
      info: {
        name: email || "",
        email: email || "",
      },
    },
  };
};

const options = getUserData();

initUserback(options)
  .then((userback) => {
    console.log("Userback initialized successfully", userback);
  })
  .catch((error) => {
    console.error("Failed to initialize Userback:", error);
  });


ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  //<React.StrictMode>
  <RollbarProvider
    config={{
      accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
      environment: import.meta.env.MODE,
      addErrorContext: true,
      captureDeviceInfo: true,
      captureUncaught: true,
      captureUnhandledRejections: true,
      codeVersion: import.meta.env.VITE_BUILD_DATE,
      payload: {
        user: {
          teacherId: localStorage.getItem("teacherId"),
          email: localStorage.getItem("email")
        }
      }
    }}
  >
    <ErrorBoundary fallbackUI={ErrorFallback}>
      <GoogleOAuthProvider clientId={config.googleClientId}>
        <Router>
          <LanguageProvider>
            <App />
          </LanguageProvider>
        </Router>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  </RollbarProvider>
  //</React.StrictMode>
);
